import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_USER_TODOS } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const todos = {
  namespaced: true,
  state: buildInitialState({
    todoList: []
  }),
  getters: {
    getField
  },
  actions: {
    getTodosWithFilters ({ dispatch, rootGetters }) {
      return dispatch('getTodos', { ...rootGetters['todoFilters/getSearchObject'] })
    },
    getTodos ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting tasks, please wait...' })

      return api.doGet({ path: PATH_USER_TODOS, parameters: filters })
        .then(json => json.data)
        .then(todos => {
          commit('updateStatus', { status: COMPLETE })
          commit('setTodos', todos)
          hideProgressModal({ dispatch })
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to get tasks')
        })
    },
    completeTodo ({ commit, dispatch }, todo) {
      return api.doPut({ path: PATH_USER_TODOS, data: todo }).then(response => {
        if (!response.data) {
          if (response.errorMessage) {
            throw new Error(response.errorMessage)
          }
          throw new Error('Unable to save task. Check required fields.')
        }

        commit('updateStatus', { status: COMPLETE })
        hideProgressModal({ dispatch })
        notifySuccess(dispatch, 'Task saved')
        dispatch('getTodosWithFilters')
        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        hideProgressModal({ dispatch })
        notifyError(dispatch, error || 'Unable to save task. Try again later')
        throw error
      })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setTodos (state, todos) {
      state.todoList = todos
    }
  }
}

export default todos
